// extracted by mini-css-extract-plugin
module.exports = {"container":"ac","copy":"bc","field":"cc","error":"dc","disabled":"ec","termsContainer":"fc","termsHeading":"gc","termsCopy":"hc","submit":"ic","srOnly":"jc"};